import { useContext } from 'react';

import AuthContext from 'src/modules/auth/AuthContext';

export const useAuth = () => useContext(AuthContext);
